import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserRegister } from '../models/userRegister-model';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {

  api = environment.api;

  constructor(private http: HttpClient) {}

  register(user: UserRegister, shareKey: string): Observable<any> {
    const headers = new HttpHeaders().set('Tart-Captcha-Key', shareKey);
    return this.http.post<any>(`${this.api}/User/Register`, user, { headers });
  }

  verifyPhoneNumberRegistration(otp: string, phoneNumber: string, referenceId: string): Observable<any> {
    const bodyRequest = {
      otp,
      referenceId,
      phoneNumber,
    };
    return this.http.post(`${this.api}/User/VerifyPhoneNumberRegistration`, bodyRequest);
  }

  login(
    email: string,
    password: string,
    captchaKey: string,
    shareKey: string,
    loginByTokenActive: boolean = false
  ): Observable<any> {
    const body = new FormData();
  
    body.append('grant_type', 'password');
    body.append('username', email);
    body.append('password', password);
    body.append('CaptchaKey', captchaKey);
    body.append('loginByTokenActive', String(loginByTokenActive));
    // body.append('loginByTokenActive', loginByTokenActive ? 'true' : 'false');
  
    const headers = new HttpHeaders().set('Tart-Captcha-Key', shareKey);
  
    return this.http.post<any>(`${this.api}/User/Login`, body, { headers });
  }
    superAdminLogin(email: string, password: string, captchaKey: string, shareKey: string, loginByTokenActive: boolean = false
    ): Observable<any> {
    var body = new FormData();
    body.append('grant_type','password');
    body.append('username',email);
    body.append('password',password);
    body.append('CaptchaKey',captchaKey);
    body.append('loginByTokenActive', String(loginByTokenActive));
    const headers = new HttpHeaders().set('Tart-Captcha-Key', shareKey);
    return this.http.post<any>(`${this.api}/User/SuperAdminLogin`,body, {headers});
  }
  verifyTwoFactorOTP(otp: string, referenceId: string): Observable<any> {
    const body = {
      otp,
      referenceId,
    };
    return this.http.post<any>(`${this.api}/User/VerifyTwoFactorOTP`, body);
  }


  logout() {
    return this.http.post<any>(`${this.api}/Token/RevokeToken`,null);
  }

  checkToken(): Observable<any> {
    return this.http.get<any>(`${this.api}/Token/CheckToken`);
  }

  refreshToken(body: any): Observable<any> {
    return this.http.post<any>(`${this.api}/Token/RefreshToken`,body,{headers:{skip:'true'}});
  }

  getActiveIdentitySettings(): Observable<any> {
    return this.http.get<any>(`${this.api}/ApplicationSetting/GetActiveIdentitySettings`,{headers:{skip:'true'}});
  }

  getCaptchaUniqueGuid(): Observable<any> {
    return this.http.post(`${this.api}/Token/GetCaptchaUniqueGuid`, {},{headers:{skip:'true'}});
  }

  getRegisterByUser(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/GetPublicGeneralSettings`, { headers: { skip: 'true' } });
  }

  getVersion(): Observable<any> {
    return this.http.get(`${this.api}/ApplicationSetting/GetVersion`, { headers: { skip: 'true' } });
  }

  forgetPassword(loginId: string): Observable<any> {
    const bodyRequest = {
      loginId,
    };
    return this.http.post(`${this.api}/User/ForgetPassword`, bodyRequest);
  }

  verifyForgetPasswordOTP(otp: string, referenceId: string): Observable<any> {
    const bodyRequest = {
      otp,
      referenceId,
    };
    return this.http.post(`${this.api}/User/VerifyForgetPasswordOTP`, bodyRequest);
  }

  setNewPassword(password: string, referenceId: string): Observable<any> {
    const bodyRequest = {
      password,
      referenceId,
    };
    return this.http.post(`${this.api}/User/SetNewPassword`, bodyRequest);
  }

  resendOTP(referenceId: string): Observable<any> {
    const bodyRequest = {
      referenceId,
    };
    return this.http.post(`${this.api}/User/ResendOTP`,bodyRequest);
  }

  checkCaptchaRequired (): Observable<any> {
    const bodyRequest = {};
    return this.http.post(`${this.api}/User/CheckCaptchaRequired`,bodyRequest, {headers:{skip:'true'}});
  }

  setSurveyStatus(payload:any): Observable<any> {
    return this.http.post<any>(`${this.api}/User/SetSurveyStatus`, payload);
  }

  getSurveyStatus(): Observable<any> {
    return this.http.get<any>(`${this.api}/User/GetSurveyStatus`);
  }

  getSsoToken(code: string, state: string, codeVerifier?): Observable<any> {
    return this.http.get<any>(`${this.api}/User/CallBack`, {params: {code, state, codeVerifier}});
  }

}
